var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDagger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336 128H224V16C224 7.125 216.875 0 208 0H176C167.125 0 160 7.125 160 16V128H48C21.5 128 0 149.5 0 176S21.5 224 48 224C68.875 224 86.5 210.625 93 192H291C297.5 210.625 315.125 224 336 224C362.5 224 384 202.5 384 176S362.5 128 336 128ZM128 428.875L178.75 504.875C185 514.375 199 514.375 205.375 504.875L256 428.875V224H128V428.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDagger);
export default __webpack_public_path__ + "static/media/dagger.4e2ec036cee68a0ac9d0e16111917b40.svg";
export { ForwardRef as ReactComponent };